function Egypt({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1111)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0Z" fill="#D80027"/>
        <path d="M16 32C22.8795 32 28.7442 27.658 31.0049 21.5652H0.995239C3.25593 27.658 9.12061 32 16 32Z" fill="black"/>
        <path d="M21.5652 14.2609H17.3913C17.3913 13.4926 16.7683 12.8696 15.9999 12.8696C15.2316 12.8696 14.6086 13.4926 14.6086 14.2609H10.4347C10.4347 15.0294 11.104 15.6523 11.8724 15.6523H11.826C11.826 16.4207 12.4489 17.0436 13.2173 17.0436C13.2173 17.812 13.8402 18.4349 14.6086 18.4349H17.3913C18.1597 18.4349 18.7826 17.812 18.7826 17.0436C19.551 17.0436 20.1739 16.4207 20.1739 15.6523H20.1276C20.8959 15.6523 21.5652 15.0294 21.5652 14.2609Z" fill="#FF9811"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Egypt;
